export default "__VITE_ASSET__BdPcoLa0__"